import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "./LeaveDetails.css";

function aTypeLabel(val) {
  if (val === "N") return "National";
  if (val === "I") return "International";
  return val || "";
}

const MyAchievements = () => {
  const [achievements, setAchievements] = useState([]);
  const [categories, setCategories] = useState([]);
  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const localUser = useMemo(() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }, []);

  const employeeId = localUser?.id;
  const moduleId = localUser?.moduleId;
  const [achiCatId, setAchiCatId] = useState("");

  useEffect(() => {
    const fetchPageData = async () => {
      if (!employeeId) {
        setError("Unauthorized access Or Session Timed out.");
        return;
      }

      try {
        const [employeeRes, categoryRes] = await Promise.all([
          axios.get("/api/employees/employee-basic", { params: { EmployeeID: employeeId } }),
          axios.get("/api/employees/achievement-categories", { params: { moduleId } })
        ]);

        setEmployeeInfo(employeeRes?.data?.data || null);
        setCategories(Array.isArray(categoryRes?.data) ? categoryRes.data : []);
      } catch (e) {
        setError("Failed to load achievement filters.");
      }
    };

    fetchPageData();
  }, [employeeId, moduleId]);

  const formatDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = String(d.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const onView = async () => {
    setError("");
    try {
      setLoading(true);
      const params = { moduleId, empId: employeeId };
      if (achiCatId) params.achiCatId = achiCatId;

      const response = await axios.get("/api/employees/achievement-details", { params });
      setAchievements(Array.isArray(response?.data?.data) ? response.data.data : []);
    } catch (e) {
      setError("Failed to fetch achievement details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="leave-details-wrap">
      <h3 className="leave-page-title">My Achievements</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="leave-filter-grid">
        <div>
          <label className="form-label" htmlFor="EmployeeID">Employee</label>
          <select className="form-control" name="EmployeeID" id="EmployeeID" value={employeeInfo?.EmployeeID || ""} disabled>
            {employeeInfo && (
              <option value={employeeInfo.EmployeeID}>
                {`${employeeInfo.EmpName} - ${employeeInfo.Designation}`}
              </option>
            )}
          </select>
        </div>

        <div>
          <label className="form-label" htmlFor="AchiCatID">Category</label>
          <select
            className="form-control"
            name="AchiCatID"
            id="AchiCatID"
            value={achiCatId}
            onChange={e => setAchiCatId(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map(item => (
              <option key={item.AchiCatID} value={item.AchiCatID}>{item.AchiCategory}</option>
            ))}
          </select>
        </div>

        <div className="leave-view-btn-wrap">
          <label className="form-label">View</label>
          <button type="button" className="btn btn-primary w-100" onClick={onView} disabled={loading}>
            {loading ? "Loading..." : "View"}
          </button>
        </div>
      </div>

      <div className="leave-results-wrap">
        <table border="1">
          <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
            <tr>
              <th>SNo</th>
              <th>Title</th>
              <th>Category</th>
              <th>Type</th>
              <th>From</th>
              <th>To</th>
              <th>Days</th>
              <th>Order Date</th>
              <th>Order No.</th>
              <th>Remarks</th>
              <th>Attachment</th>
            </tr>
          </thead>
          <tbody>
            {achievements.map((item, index) => (
              <tr key={item.AchievementID}>
                <td>{index + 1}</td>
                <td>{item.Title}</td>
                <td>{item.AchiCategory}</td>
                <td>{aTypeLabel(item.AType)}</td>
                <td>{formatDate(item.FromDate)}</td>
                <td>{formatDate(item.ToDate)}</td>
                <td>{item.NoOfDays}</td>
                <td>{formatDate(item.OrderDate)}</td>
                <td>{item.OrderNumber}</td>
                <td>{item.Remarks}</td>
                <td>
                  {item.SupportDoc ? (
                    <button
                      type="button"
                      onClick={() => window.open(`/api/${item.SupportDoc}`, "_blank", "noopener,noreferrer")}
                    >
                      Attachment
                    </button>
                  ) : null}
                </td>
              </tr>
            ))}
            {!loading && achievements.length === 0 && (
              <tr>
                <td colSpan="11" className="leave-empty-row">No records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyAchievements;
